export { default as CoronaSolidIcon } from './CoronaSolidIcon';
